export const ROUTING = {
  PHONE_NUMBER: 'phone-number',
  PHONE_NUMBER_OTP: 'phone-number-otp',
  EDO_APP_EID: 'edo-app-eid',
  EDO_APP_VERIFICATION: 'edo-app-verification',
  M_OBYWATEL: 'm-obywatel',
  SERVICE_UNAVAILABLE: 'service-unavailable',
  FREE_SIGNATURES: 'free-signatures',
  FREE_SIGNATURES_COMMERCIAL: 'fsc',
};
